module.exports = __webpack_public_path__ + "img/logo-branco.08057788.svg";